import { render, staticRenderFns } from "./CalendarDisplay.vue?vue&type=template&id=c42a9e56&scoped=true"
import script from "./CalendarDisplay.vue?vue&type=script&lang=js"
export * from "./CalendarDisplay.vue?vue&type=script&lang=js"
import style0 from "./CalendarDisplay.vue?vue&type=style&index=0&id=c42a9e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42a9e56",
  null
  
)

export default component.exports